import { narrowSymbolTest } from '@marketplace/helpers/numberFormats.js'
/**
 * Shows the translation keys for marketing.
 *
 * @param {object} context
 * @param {object} context.app
 */
export default function ({ app }) {
    enableShowTranslationsFeatureFlag()
    setFallbackNumberFormat()

    /**
     * Test if the browser supports the narrow currency symbol and use symbol as a fallback when it doesn't
     * This is mainly for older Safari version.
     */
    function setFallbackNumberFormat() {
        const showNarrowSymbol = Boolean(narrowSymbolTest())

        if (showNarrowSymbol) {
            return
        }

        for (const [locale] of Object.entries(app.i18n.numberFormats)) {
            app.i18n.mergeNumberFormat(locale, {
                currency: {
                    currencyDisplay: 'symbol',
                },
                'currency-no-decimal': {
                    currencyDisplay: 'symbol',
                },
            })
        }
    }

    /**
     * Show the translations keys with a feature flag (?showtranslations=1)
     */
    function enableShowTranslationsFeatureFlag() {
        const disabledTranslations =
            window.location.search.includes('showtranslations')

        if (!disabledTranslations) {
            return
        }

        app.i18n.silentFallbackWarn = true
        app.i18n.silentTranslationWarn = true
        app.i18n.postTranslation = (value, key) => `components.${key}`
        app.i18n.setLocaleMessage(app.i18n.locale, null)
    }
}
